module.exports = __webpack_public_path__ + "img/observa4.9a9e69ab.jpg";